var render = function render(){var _vm=this,_c=_vm._self._c;return _c('perseu-card',{staticClass:"rounded-xl text-center",attrs:{"elevation":"0","title":_vm.title,"title-center":"","class-title":"subtitle-1 secondary--text"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }